import $ from 'gridstrap/lib/gs-zepto';

export class GSTestimonialCarouselItem {

	//
	// Properties
	//

	private root;
	private quote;
	wordsPerMinute = 175;
	minReadingTime = 5000;

	get readingTime() {
		let words = this.wordCount;
		let time = words / this.wordsPerMinute * 60000;
		return Math.max(time, this.minReadingTime);
	}

	get wordCount() {
		return this.quote.text()
			.replace(/[\n\t]/g, ' ') // Newlines & tabs → spaces
			.replace(/ {2,}/g, ' ')  // Remove duplicate spaces
			.split(' ').length;
	}

	//
	// Initializations & Event Handlers
	//

	constructor(root) {
		this.root = $(root);
		this.quote = this.root.find('.gs-TestimonialCarousel-quote');
	}
}
